import { render, staticRenderFns } from "./visa.vue?vue&type=template&id=c12a376c&scoped=true"
import script from "./visa.vue?vue&type=script&lang=js"
export * from "./visa.vue?vue&type=script&lang=js"
import style0 from "./visa.vue?vue&type=style&index=0&id=c12a376c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12a376c",
  null
  
)

export default component.exports